export default [
  {
    id: 'profile',
    title: 'プロフィール',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'address',
    title: '住所',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'contacts',
    title: '連絡先',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'id-photo',
    title: '証明写真',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'edu-historyOsaka',
    title: '学歴',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'job-history',
    title: '職歴',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'research_detail',
    title: '研究内容など',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'reasonOsaka_1',
    title: '自己PR１',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'reasonOsaka_2',
    title: '自己PR２',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'requestsOsaka',
    title: '志望動機',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'create-date',
    title: '作成日',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'output',
    title: 'ダウンロード',
    previewJumpId: 'close-preview-button-above'
  }
]
